import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Analytics from "@/components/Analytics";
import OgCard from "@/components/OgCard";
import AppLanding from "@/pages/AppLanding";
import AdminAnalytics from "@/pages/AdminAnalytics";
import { APPS } from "@/config";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: 80, fontFamily: "sans-serif" }}>
          <h1>Something went wrong.</h1>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

function SmoothScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96, duration: 1.2 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, 90);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function Chrome() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/og-card")) return null;
  return <Nav />;
}

function FooterChrome() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/og-card")) return null;
  return <Footer />;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <Analytics />
        <Chrome />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            {APPS.map((a) => (
              <Route key={a.id} path={a.path} element={<AppLanding appId={a.id} />} />
            ))}
            <Route path="/apoum" element={<Navigate replace to={APPS[1].path} />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/og-card" element={<OgCard />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <FooterChrome />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
